<template><div><h1>VUX V2.1.1Rc.7 released</h1>
<h2><a href="/en/components/datetime.html">Datetime</a></h2>
<ul><li>[enhance] Support PC mouse drag  #1039 @michael829</li>
</ul>
<h2><a href="/en/components/picker.html">Picker</a></h2>
<ul><li>[enhance] Support PC mouse drag  #1039 @michael829</li>
</ul>
<h2><a href="/en/components/popup-picker.html">PopupPicker</a></h2>
<ul><li>[enhance] Support PC mouse drag  #1039 @michael829</li>
<li>[enhance] Support prop:display-format</li>
</ul>
<h2><a href="/en/components/swipeout.html">Swipeout</a></h2>
<ul><li>[fix] Fix button click on Android. #1044 @tangtaoit</li>
</ul>
<h2><a href="/en/components/tab.html">Tab</a></h2>
<ul><li>[feature] Support setting bar width with prop:custom-bar-width</li>
<li>[fix] Fix errors when initializing without tab-item #1038 @liu2010y</li>
</ul>
<h2><a href="/en/components/x-address.html">XAddress</a></h2>
<ul><li>[enhance] Support PC mouse drag  #1039 @michael829</li>
</ul>
<h2><a href="/en/components/x-number.html">XNumber</a></h2>
<ul><li>[fix] Emit on-change after nextTick</li>
</ul></div></template><script>
export default {
  head: {"title":"VUX V2.1.1Rc.7 released | VUX - Vue.js Mobile UI Component Framework","ignoreSuffixChar":"|"}
}
  </script>


// WEBPACK FOOTER //
// v2.1.1-rc.7-96.vue?9f30b492